import { render, staticRenderFns } from "./RightVolatility.vue?vue&type=template&id=32fddd71&scoped=true"
import script from "./RightVolatility.vue?vue&type=script&lang=js"
export * from "./RightVolatility.vue?vue&type=script&lang=js"
import style0 from "./RightVolatility.vue?vue&type=style&index=0&id=32fddd71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fddd71",
  null
  
)

export default component.exports